import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Al completar el pago recibes un email con acceso inmediato a todos los PDFs. Descárgalos en tu teléfono, tablet o computadora y úsalos desde hoy mismo.'
}, {
  q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
  a: 'Sí para los dos. Si eres nueva: tienes todo organizado desde el primer día. Si ya tienes experiencia: vas a encontrar ideas, variaciones y estructuras que no tenías sistematizadas.'
}, {
  q: '¿Qué incluye exactamente el Pack Completo por $19.90 USD?',
  a: 'El Pack Completo incluye todo el sistema PILATES 360: los 6 Tomos de Reformer, los 6 Tomos de Mat y los 6 Bonus estratégicos. Todo en un solo pago, sin suscripciones mensuales.'
}, {
  q: '¿Qué diferencia hay con otros materiales de Pilates que ya existen?',
  a: 'PILATES 360 es el único sistema pensado específicamente para el instructor de habla hispana, con progresión real por niveles, ejercicios graficados, Reformer y Mat en un solo lugar, y un plan anual completo incluido.'
}, {
  q: '¿Sirve para grupos con niveles mezclados?',
  a: 'Sí. Cada tomo incluye variaciones esencial, clásica y avanzada del mismo ejercicio para que des una sola clase con tres niveles sin planificar tres veces.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tienes 7 días de garantía total. Si por cualquier motivo no es lo que esperabas, te devolvemos el 100% del pago. Sin formularios ni preguntas.'
}, {
  q: '¿Vale la pena si ya planifico bien mis clases?',
  a: 'Si ya planificas bien, el sistema va a darte variaciones nuevas de los ejercicios que ya usas. Y el Planner de Sesiones te va a dar el año completo estructurado sin trabajo extra. El tiempo que ahorras en un mes ya justifica la inversión.'
}, {
  q: '¿Puedo pagar con tarjeta de crédito?',
  a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y opciones de pago locales según tu país.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-white" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        {/* FAQ Section */}
        <div data-id="element-55">
          <h2 className="text-4xl font-serif font-bold text-brand-charcoal mb-12 text-center" data-id="element-56">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-57">
            {faqs.map((faq, i) => <div key={i} className="border border-brand-sand rounded-xl overflow-hidden" data-id="element-58">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex justify-between items-center bg-brand-cream hover:bg-brand-sand/20 transition-colors" data-id="element-59">
                  <span className="font-bold text-brand-charcoal pr-4" data-id="element-60">
                    {faq.q}
                  </span>
                  <ChevronDown className={`transform transition-transform duration-300 text-brand-terracotta flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-61" />
                </button>
                <AnimatePresence data-id="element-62">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-63">
                      <div className="px-6 py-4 bg-white text-gray-600 leading-relaxed border-t border-brand-sand" data-id="element-64">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};